// Core
import styled from "styled-components";

export const StyledToolbar = styled.div`
  position: absolute;
  right: 10px;
  top; 10px;
`;
